import React from 'react';

import PropTypes from 'prop-types';

import { combineClasses } from 'wanderu-css';

import Link from '../Link/Link';
import { anchorLinkPropType } from './utils';

import styles from './TableOfContentsItem.scss';

function TableOfContentsItem(props) {
    const {
        classes: classesProp = {},
        component: Component = 'li',
        componentProps = {},
        href,
        text,
        onClick = () => { },
        ...otherProps
    } = props;

    const classes = combineClasses(styles, classesProp);

    return (
        <Component
            className={classes.root}
            {...otherProps}
            {...componentProps}
        >
            <Link
                className={classes.link}
                href={href}
                onClick={onClick}
                variant="toc"
            >
                {text}
            </Link>
        </Component>
    );
}

TableOfContentsItem.propTypes = {
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
    * The component used for the root node.
    * Either a string to use a HTML element or a component.
    */
    component: PropTypes.elementType,
    /**
     * The set of component props passed down to the root component
     */
    componentProps: PropTypes.object,
    /**
    * The in-page url that the anchor tag will link to.
    * A string beginning with '#'.
    */
    href: anchorLinkPropType,
    /**
    * Optional function fired by clicking on anchor link
    */
    onClick: PropTypes.func,
    /**
    * Text for the anchor link.
    */
    text: PropTypes.string.isRequired,
};

export default TableOfContentsItem;
